/**
 * Creates a proxy script from the given source.
 * @param source
 * @param scriptId
 * @param esm
 */
export function createProxyScript(source, scriptId, esm) {
    if (esm === void 0) { esm = false; }
    var script = document.createElement('script');
    script.src = source;
    script.id = scriptId;
    script.async = true;
    if (esm) {
        script.type = 'module';
    }
    else {
        script.type = 'text/javascript';
        script.noModule = true;
    }
    return script;
}
/**
 * Checks if the script is already loaded (via script ID) and appends if
 * not.
 * @param script
 */
export function appendProxyScript(script) {
    if (!document.head.querySelector("#".concat(script.id))) {
        document.head.appendChild(script);
    }
}
/**
 * Creates a unique script ID from the script selector and its sourcemap id (esm/js)
 * @param selector
 * @param esm
 */
export function createScriptId(selector, esm) {
    if (esm === void 0) { esm = false; }
    return "".concat(selector, "-script-").concat(esm ? 'esm' : 'js');
}
